import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register required Chart.js components
ChartJS.register(
  CategoryScale,      // Required for bar/line charts
  LinearScale,        // Required for bar/line charts
  PointElement,       // Required for line/radar charts
  LineElement,        // Required for line/radar charts
  BarElement,         // Required for bar charts
  RadialLinearScale,  // Required for radar charts
  ArcElement,         // Required for doughnut charts
  Tooltip,
  Legend,
  Filler             // Required for area fills
);

// Configure default options
ChartJS.defaults.responsive = true;
ChartJS.defaults.maintainAspectRatio = false;

// Add custom destroy handler
const originalDestroy = ChartJS.prototype.destroy;
ChartJS.prototype.destroy = function() {
  if (this.canvas) {
    // Clear the canvas before destroying
    const ctx = this.canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }
  originalDestroy.call(this);
};